export const PREFIX = "club-gifts-galore";
